import React from "react";

function Solution() {
  return (
    <div className="Solution">
      <main className="font-nunito">
        <section className="pt-16 mb-11">
          <div id="jumbotron relative">
            <img className="w-full" src="./img/solutionjumbo.webp" alt="" />
            {/* <div className="absolute flex  flex-col justify-center w-full xl:w-2/5  bg-black bg-opacity-70 top-16 xl:top-24 p-4 xl:p-9 text-white">
              <h1 className=" font-secular text-sm xl:text-3xl">
                CREATE BEAUTIFULLY <br /> DESIGNED CONTENTS WITHIN{" "}
              </h1>
              <h1 className="text-main-color text-base xl:text-5xl font-bold font-secular mt-1 xl:mt-3">
                5 MINUTES
              </h1>
              <p className="font-nunito text-xs xl:text-base font-normal mt-1 xl:mt-9">
                Impressive Content, Easy Management And Targeted Marketing To
                Improve Your Customer Experience
              </p>

              <div className="flex mt-1 xl:mt-10">
                <button className=" text-sm text-white bg-main-color mr-4 mt-2  xl:p-3 xl:px-11 px-4 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Free Trial</a>
                </button>
                <div>
                  <div className="flex items-center">
                    <img src="./img/star.png" alt="" />
                    <img src="./img/star.png" alt="" />
                    <img src="./img/star.png" alt="" />
                    <img src="./img/star.png" alt="" />
                    <img src="./img/star.png" alt="" />
                  </div>
                  <div className="flex flex-col text-xs xl:text-base">
                    <p>Based On</p>
                    <p>1000+ Reviews</p>
                  </div>
                </div>
              </div>
              <p className="font-nunito font-normal mt-9 pb-6">
                (30 Day Trial – No Credit Card Required)
              </p>
            </div> */}
          </div>
          <h2 className="text-heading-color font-semibold text-2xl mt-10 lg:mb-20 text-center p-4">
            Panelo help digital transformation at respectable organization:
          </h2>
          <ul className="flex justify-center items-center">
            <li className="mx-2 lg:mx-7">
              <img src="./img/bni.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/tsm.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/abb.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/danone.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/pwc.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/dep-pertanian.png" alt="" />
            </li>
          </ul>
        </section>

        {/* Jumbotron Section End Here */}

        {/* Cloud Base Digital Start Here */}
        <section className="bg-hero-pattern">
          <img
            className="lg:absolute hidden lg:block w-full"
            src="./img/bg-cloud.png"
            alt=""
          />
          <div className="absolute">
            <h2 className="text-main-color text-xl mb-4 lg:text-4xl lg:pt-5 xl:pt-28 font-bold text-center">
              CLOUD BASE DIGITAL SIGNAGE SOLUTION
            </h2>

            <div className="flex px-4 flex-col lg:py-3 xl:py-14 md:flex-row justify-center items-center lg:px-32">
              <div className="md:w-6/12">
                <iframe
                  className="w-full lg:w-full md:h-72"
                  src="https://www.youtube.com/embed/yF8nZJNn6z8?controls=0"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
              <div
                className="md:w-6/12 lg:ml-9 font-poppins text-sm px-6 py-3 
              "
              >
                <p className="mb-4 lg:mb-9 w">
                  Panelo Sign provides one-stop digital signage solution,
                  through a combination of displays, media player, a
                  simple-to-use software empowered by Artificial Intelligent
                  with wide range of valuable tools for your business. ​
                </p>
                <p>
                  Comparing with others that the solution exclusively focusing
                  on hardware, Panelo Sign integrates both between software and
                  hardware for optimal efficiency and user experience offering
                  real-time, flexible, scalable solutions for customers –
                  accommodating digital signage needs of all customer types and
                  sizes. Our platform is meant to easily adjust to the changing
                  signage needs of your business
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="mt-96 pt-72 xl:pt-80">
          <h2 className="text-main-color text-4xl pt-6 md:pt-11 font-bold text-center">
            WHY PANELO
          </h2>

          <div className="solution flex flex-col lg:flex-row justify-center p-4 lg:p-20 lg:px-28">
            <div className="sign border-b-2 lg:border-b-0 lg:border-r-2 border-dashed p-5 lg:w-4/12">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/1.png"
                  width="175"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-orange-dark text-center">
                  Scalable And Secure
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  1,2 or 100.000 display? you decide the limit. Easily deliver
                  your message into displays in a snap, Powered by Amazon Web
                  Services, that known as reliable cloud services with
                  state-of-the-art security practices to ensure 24/7 operation
                  anywhere in the world.​
                </p>
              </div>
            </div>
            <div className="border-b-2 lg:border-b-0 lg:border-r-2 border-dashed p-5 lg:w-4/12">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/2.png"
                  width="175"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-orange-dark text">
                  Centralize Management​
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Panelo allows you to create, schedule content and publish
                  real-time content remotely. Execute campaign and engage with
                  audience from anywhere in the world, using easy-to-use Content
                  Management System from any device, ensuring operations
                  continue running smoothly even while you’re on vacation or
                  away from the office.​
                </p>
              </div>
            </div>
            <div className="border-b-2 lg:border-b-0 border-dashed p-5 lg:w-4/12">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/6.png"
                  width="175"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-orange-dark ">
                  Interactive Display​
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Panelo offers capability to use touchscreen display with
                  interactive content to help interact and engage with your
                  audience. These include: ​
                </p>
              </div>
              <div className="pl-3 pt-3">
                <li className="text-left">​Self Service Kiosk</li>
                <li className="text-left">​Queue Management​</li>
                <li className="text-left">​QR Code</li>
                <li className="text-left">​​Wayfinding</li>
                <li className="text-left">​​​People Count</li>
                <li className="text-left">​​​Audience Measurement​</li>
              </div>
            </div>
          </div>
          <div className="solution flex flex-col lg:flex-row justify-center p-4 lg:p-9 lg:px-28">
            <div className="sign border-b-2 lg:border-b-0 lg:border-r-2 border-dashed p-5 lg:w-4/12 ">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/5.png"
                  width="175"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-orange-dark text-center">
                  Adaptive Campaign​
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Panelo provide integration with your business's backend system
                  or IoT (internet of Things), with features including:
                </p>
              </div>
              <div className="pl-3 pt-3">
                <li className="text-left">​Programmatic Advertising​</li>
                <li className="text-left">​Alert System​</li>
                <li className="text-left">​Data and Status Update</li>
                <li className="text-left">​​Social Media wall</li>
                <li className="text-left">​​​People Count</li>
                <li className="text-left">​​​Audience Measurement​</li>​
              </div>
              <p>
                The system can automatically change your signage content to
                support your campaign changing items.​
              </p>
            </div>
            <div className="border-b-2 lg:border-b-0 lg:border-r-2 border-dashed p-5 lg:w-4/12">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/4.png"
                  width="175"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-orange-dark text">
                  Widget Application​
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Panelo provide real time and informative widgets such as
                  Weather, RSS feeds, Time, images and video streaming or
                  webpages to engage with passing customer.​ Users have the
                  option to put their web application as widget and interactive
                  signage.​
                </p>
              </div>
            </div>
            <div className="border-b-2 lg:border-b-0 border-dashed p-5 lg:w-4/12">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/3.png"
                  width="175"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-orange-dark ">
                  Time and Cost Effective​
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Panelo provide Display as A Services, including content
                  management and daily operation, the services will save time
                  and money that allows you to invest your engergy into core and
                  demanding areas of business​
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* Our Solution Section End Here */}

        {/* Hardware Section Start Here */}
        <section>
          <h2 className="text-main-color text-4xl pt-16 mb-5 font-bold text-center">
            HARDWARE
          </h2>

          <div className="solution flex flex-col lg:flex-row justify-center p-4 lg:px-28">
            <div className="shadow-lg hover:shadow-xl rounded-md lg:w-4/12 p-4 mx-6 mb-9">
              <div className="flex flex-col items-center">
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-desc-text text-center">
                  Dont't Have Display?
                </h3>
                <img
                  loading="lazy"
                  src="./img/7.png"
                  width="175"
                  className=""
                  alt=""
                />
                ​
              </div>
              <div className="font-poppins">
                <p className="text-left">Choose Your Display:</p>
                <ul className="list-disc pl-6">
                  <li>
                    Any size with Android Operating System, Windows or Tizen​
                    Landscape and/or portrait display orientation
                  </li>
                  <li>Resolution Full HD or 4K​</li>
                  <li>16/7 or 24 operational hours​​</li>
                  <li>Panelo Sign subscription​​</li>
                </ul>
              </div>
              <div className="flex justify-center items-center">
                <button className="text-white bg-main-color mt-10 p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Buy Now</a>
                </button>
              </div>
            </div>
            <div className="shadow-lg hover:shadow-xl rounded-md lg:w-4/12 p-4 mx-6  mb-9">
              <div className="flex flex-col items-center">
                <h3 className="font-robotoslab mb-9 text-xl font-bold text-desc-text text-center">
                  Already Have Display?
                </h3>
                <img
                  loading="lazy"
                  src="./img/8.png"
                  width="195"
                  className=""
                  alt=""
                />
              </div>
              <div className="font-poppins mt-16">
                <p className="text-left">Choose Your Media Player:</p>
                <ul className="list-disc pl-6">
                  <li>Mini PC with Windows 10 OS​</li>
                  <li>Android Box with Android 7 and above​​</li>
                  <li>Single or Videowall mode​​​</li>
                  <li>16/7 or 24 hrs operational hours​​​</li>
                  <li>Panelo Sign subscription​​​</li>
                </ul>
              </div>
              <div className="flex justify-center items-center">
                <button className="text-white bg-main-color mt-16 p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Buy Now</a>
                </button>
              </div>
            </div>
            <div className="shadow-lg hover:shadow-xl rounded-md lg:w-4/12 p-4 mx-6  mb-9">
              <div className="flex flex-col items-center">
                <h3 className="font-robotoslab mb-5 text-xl font-bold text-desc-text text-center">
                  Need Custom or Enterprise class deployment?​
                </h3>
                <img
                  loading="lazy"
                  src="./img/9.png"
                  width="175"
                  className=""
                  alt=""
                />
                ​
              </div>
              <div className="font-poppins">
                <p className="text-left">Custom Deployment:</p>
                <ul className="list-disc pl-6">
                  <li>On-Premise deployment​</li>
                  <li>Custom IoT/Sensor/Application deployment​</li>
                  <li>Kiosk Application​​​</li>
                  <li>OEM or White label​</li>
                </ul>
              </div>
              <div className="flex justify-center items-center">
                <button className="text-white bg-main-color mt-20  p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Buy Now</a>
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* Hardware Section End Here */}

        {/* 3 easy step Section Start Here */}
        <section className="mb-9 mt-9">
          <h2 className="text-main-color text-4xl pt-16 mb-7 font-bold text-center">
            3 EASY STEPS TO PUBLISH YOUR CONTENT​
          </h2>

          <div className="solution flex flex-col lg:flex-row justify-center p-4 lg:px-28">
            <div className="lg:w-4/12 p-4 mx-6">
              <div className="flex flex-col items-center pt-6">
                <img
                  loading="lazy"
                  src="./img/mobile-login.png"
                  width="200"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mt-5 text-xl font-bold text-desc-text text-center">
                  Login To Portal
                </h3>
                ​
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-center">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
                <button className="text-white bg-main-color mt-10 p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Get Started</a>
                </button>
              </div>
            </div>
            <div className="lg:w-4/12 p-4 mx-6">
              <div className="flex flex-col items-center pt-6">
                <img
                  loading="lazy"
                  src="./img/content.png"
                  width="275"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mt-5 text-xl font-bold text-desc-text text-center">
                  Create Your Content
                </h3>
                ​
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-center">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
                <button className="text-white bg-main-color mt-10 p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Get Started</a>
                </button>
              </div>
            </div>
            <div className="lg:w-4/12 p-4 mx-6">
              <div className="flex flex-col items-center">
                <img
                  loading="lazy"
                  src="./img/publication.png"
                  width="220"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mt-2 text-xl font-bold text-desc-text text-center">
                  Publish Your Display
                </h3>
                ​
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-center">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </p>
                <button className="text-white bg-main-color mt-10 p-3 pl-11 pr-11 mb-5 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Get Started</a>
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* Hardware Section End Here */}
      </main>
    </div>
  );
}

export default Solution;
